module.exports = __webpack_public_path__ + "img/flight-off.769128dc.svg";